@if (shouldDisplaySidebarShoppingCart) {
  <div class="sidebar-cart">
    <app-cart-preview></app-cart-preview>
  </div>
}
